<template>
  <div>
    <div>
      <header class="main-content--header">
        <div class="columns">
          <div class="column left">
            <h4>Admin</h4>
          </div>
          <div class="column right">
            <router-link to="/admin">
              <i class="fa fa-arrow-circle-o-left" aria-hidden="true"></i> Back
          </router-link>
          </div>
        </div>
      </header>
      <section class="main-content--body">
        <div class="wrapper-md">
          <div class="main-content--panel">
            <div class="loading-icon" v-if="loading">
              <span class="slack-loader"></span>
            </div>
            <div class="panel--top" v-if="reports">
              <h3>{{name}}'s Sign Ins - <span>{{totaltime}}</span></h3>
              <div class="users--table">
                <table>
                  <thead>
                  <tr>
                    <th>Duration</th>
                    <th>Date</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in reports">
                    <td>{{item.time}}</td>
                    <td>{{item.date}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'
  import tz from 'moment-timezone'
  import { store } from '../../store/store'
  export default {
    name: 'User',
    data () {
      return {
        totaltime: null,
        reports: null,
        loading: false,
        name: null
      }
    },
    created () {
      this.fetchData()
    },
    watch: {
      '$route': 'fetchData'
    },
    methods: {
      fetchData () {
        this.loading = true
        let self = this
        axios.get('https://api.kuzcoapp.com/api/v1/team')
          .then(function (response) {
            var _team = response.data.data.name
            var _id = response.data.data.id
            var _slackid = response.data.data.slack_id
            axios.get('https://api.kuzcoapp.com/api/v1/admin/reports/' + _slackid + '?user_id=' + self.$route.params.id + '&start=2017-01-01&end=2020-01-01')
              .then( function(response) {
                self.loading = false
                var _totaltime = response.data.data[0].results.total_time
                var _reports = response.data.data[0].results.reports
                self.name = response.data.data[0].user.name
                function secondsToHumanize (time) {
                  time = moment.duration(time, "seconds").humanize();
                  return time
                }
                self.totaltime = secondsToHumanize(_totaltime)
                var _rep = {}
                for (var i in _reports) {
                  var _time = _reports[i].time
                  var _date = _reports[i].date
                  _time = secondsToHumanize(_time)
                  _date = moment(_date).format('MMMM Do YYYY')
                  _rep[i] = {
                    date: _date,
                    time: _time
                  }
                }
                self.reports = _rep
              })
              .catch(function (error) {
              });
          })
          .catch(function (error) {
          });
      }
    },
    computed: {
      teamid () {
        return store.state.teamid;
        this.slackteamid = this.$store.state.teamid;
      },
      teamslackid () {
        return store.state.teamslackid;
        this.slackid = this.$store.state.teamslackid;
      }
    }
  }
</script>

<style scoped lang="scss" type="text/scss">
  $themecolor: #4671fb;
  $oldthemecolor: #3e454f;
  $kuzcogreen: #40CF97;
  .router-link-active {
    border-bottom: 0;
  }
  h3 {
    font-size: 20px;
    margin-bottom: 20px;
    span {
      font-family: "Proxima Bold";
    }
  }
  .main-content--header {
    .right {
      color: $oldthemecolor;
      text-align: right;
      a {
        border-bottom: 0;
        color: $oldthemecolor;
        font-size: 18px;
      }
      i {
        margin-right: 5px;
        margin-top: 6px;
      }
    }
  }
  .main-content--body{
    height: 100vh;
  }
  .status {
    border-radius: 100%;
    width: 8px;
    height: 8px;
    border-width: 4px;
    color: $kuzcogreen;
    border-style: solid;
    display: inline-block;
  }
  table {
    font-size: 14px;
  }
  th {
    padding: 15px;
    border-bottom: 1px solid #D7E2E9;
  }
  td {
    padding: 15px;
    border-top: 1px solid #D7E2E9;
  }
  .loading-icon {
    padding-top: 50px;
    padding-bottom: 50px;
  }
  .slack-loader {
    margin: 0 auto;
    display: flex;
    /*display: inline-block;*/
    /*margin: 0 15px;*/
    font-size: 12px;
    text-indent: -9999em;
    width: 3em;
    height: 3em;
    border-radius: 50%;
    background: #ffffff;
    background: -moz-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    background: -webkit-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    background: -o-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    background: -ms-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    background: linear-gradient(to right, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    position: relative;
    -webkit-animation: load3 1.4s infinite linear;
    animation: load3 1.4s infinite linear;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }
  .slack-loader:before {
    width: 50%;
    height: 50%;
    background: $kuzcogreen;
    border-radius: 100% 0 0 0;
    position: absolute;
    top: 0;
    left: 0;
    content: '';
  }
  .slack-loader:after {
    background: #ffffff;
    width: 75%;
    height: 75%;
    border-radius: 50%;
    content: '';
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
  @-webkit-keyframes load3 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load3 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// User.vue?6c7e47d4